import { render, staticRenderFns } from "./DevisForm.vue?vue&type=template&id=37a6677c&scoped=true"
import script from "./DevisForm.vue?vue&type=script&lang=js"
export * from "./DevisForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a6677c",
  null
  
)

export default component.exports